var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.22 76.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path72",
    className: "cls-1",
    d: "M64.14,7.45c-1.9-1.7-9.5-7.3-26.6-7.4,0,0-20.1-1.2-29.9,7.8C2.15,13.35.25,21.25.05,31.15s-.5,28.4,17.39,33.5v7.7s-.1,3.1,1.9,3.7c2.5.8,3.9-1.6,6.3-4.1,1.3-1.4,3.1-3.4,4.4-5a68,68,0,0,0,22.7-1.7c2.5-.8,16.4-2.6,18.7-21.1,2.4-19.2-1-31.3-7.3-36.7Zm2.1,35.2c-1.9,15.5-13.2,16.5-15.3,17.1a65,65,0,0,1-19.5,1.7s-7.7,9.3-10.2,11.8a1.53,1.53,0,0,1-1.1.5c-.4-.1-.5-.6-.5-1.3,0-1,.1-12.8.1-12.8-15.09-4.2-14.19-20-14.09-28.3s1.7-15,6.29-19.6c8.3-7.5,25.4-6.4,25.4-6.4,14.4.1,21.3,4.4,22.9,5.9,5.2,4.6,7.9,15.5,6,31.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    className: "cls-2",
    d: "M44.54,30.75c-.2-3.8-2.1-5.8-5.8-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    className: "cls-2",
    d: "M49.54,32.35a12.18,12.18,0,0,0-3.1-8.8,13,13,0,0,0-9-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    className: "cls-2",
    d: "M54.54,34.35c0-6.1-1.9-10.9-5.5-14.4a18.63,18.63,0,0,0-13.5-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    className: "cls-1",
    d: "M38.94,43.65a2.68,2.68,0,0,0,2.1-.8l1.4-1.8a3.15,3.15,0,0,1,4-.6,29.84,29.84,0,0,1,3.5,2.3c1.1.8,3.3,2.6,3.3,2.6a2.74,2.74,0,0,1,.6,3.6,12.52,12.52,0,0,1-3,3.6,6.08,6.08,0,0,1-3,1.5h-.4a5.85,5.85,0,0,1-1.3-.2,45.83,45.83,0,0,1-8.3-3.8,51.55,51.55,0,0,1-6.9-4.6,26.13,26.13,0,0,1-3.1-2.8l-.4-.4a37.32,37.32,0,0,1-2.8-3.1,51.55,51.55,0,0,1-4.6-6.9c-2.3-4.2-3.4-6.7-3.8-8.3a5.07,5.07,0,0,1-.2-1.3v-.4a5.34,5.34,0,0,1,1.5-3,16.89,16.89,0,0,1,3.6-3,2.74,2.74,0,0,1,3.6.6s1.8,2.2,2.6,3.3,1.7,2.6,2.3,3.5a3.31,3.31,0,0,1-.5,4l-1.8,1.4a2.68,2.68,0,0,0-.8,2.1s2.5,9.9,12.4,12.5Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViber);
export default __webpack_public_path__ + "static/media/Viber.114b89af.svg";
export { ForwardRef as ReactComponent };